import { render, staticRenderFns } from "./page-loader-cmp.vue?vue&type=template&id=6acf6d4e&scoped=true&"
import script from "./page-loader-cmp.vue?vue&type=script&lang=js&"
export * from "./page-loader-cmp.vue?vue&type=script&lang=js&"
import style0 from "./page-loader-cmp.vue?vue&type=style&index=0&id=6acf6d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf6d4e",
  null
  
)

export default component.exports